module.exports = __webpack_public_path__ + "img/block6-card10.9aed2865.svg";